import Route from '@ember/routing/route';
import { service } from '@ember/service';
import AbilitiesService from 'donor-elf-web/services/abilities';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export default class TntConnectImportXmlRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare navbarSettings: NavbarSettingsService;

  beforeModel() {
    this.navbarSettings.title = 'Import from TntConnect';
  }

  model() {
    return {
      selectedFile: null,
      includeGifts: false,
      includeTasks: true,
      includeHistory: true,
      includeGroups: true,
      includePledges:
        this.abilities.hasAbility('edit_pledges') ||
        this.abilities.hasAbility('edit_manual_pledges') ||
        false,
    };
  }
}
